import { render, staticRenderFns } from "./Translation.vue?vue&type=template&id=18e9f7a8"
import script from "./Translation.vue?vue&type=script&lang=js"
export * from "./Translation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports